








































































































import { Component, Watch, Vue } from 'vue-property-decorator';
import {
    AlbumFile,
    Decade,
    Popularity,
    Reception,
    SortOrder,
} from '@/store/albums/types';

@Component({})
export default class AlbumFilters extends Vue {
    albumFile: AlbumFile = this.$store.getters['albums/albumFile'];

    sortOrder: SortOrder = this.$store.getters['albums/sortOrder'];

    criticalReception: Reception = this.$store.getters['albums/reception'];

    releaseDecade: Decade = this.$store.getters['albums/releaseDecade'];

    popularity: Popularity = this.$store.getters['albums/popularity'];

    albumFileAll = AlbumFile.all;

    albumFileNoMetal = AlbumFile.noMetal;

    @Watch('sortOrder')
    sortOrderSelected(sortOrder: SortOrder) {
        this.$store.commit('albums/setSortOrder', sortOrder);
    }

    @Watch('criticalReception')
    receptionSelected(criticalReception: Reception) {
        this.$store.commit('albums/setReception', criticalReception);
    }

    @Watch('releaseDecade')
    decadeSelected(releaseDecade: SortOrder) {
        this.$store.commit('albums/setReleaseDecade', releaseDecade);
    }

    @Watch('popularity')
    popularitySelected(popularity: Popularity) {
        this.$store.commit('albums/setPopularity', popularity);
    }

    @Watch('albumFile')
    albumFileSelected(albumFile: AlbumFile) {
        this.$store.commit('albums/setAlbumFile', albumFile);
    }
}
